module.exports = __webpack_public_path__ + "static/media/clamp.489ae747.png";